import React, { Component, ReactNode } from 'react';
import FormicaLabel from '../../../../custom/FormicaLabel';

class GeneralConfigurationItemContainer extends Component<Props> {
  render() {
    return (
      <div className={`flex items-center w-full gap-x-40 border-b py-5 ${this.props.className ?? ""}`}>
        <div className={"flex w-full max-w-[400px] flex-col"}>
          <FormicaLabel label={this.props.header}/>
          <p className={"text-sm 2xl:text-md text-f-black-3 font-normal"}>
            {this.props.description}
          </p>
        </div>
        {this.props.children}
      </div>
    );
  }
}

interface Props {
  header: string;
  description: string;
  children: ReactNode;
  className?: string;
}

export default GeneralConfigurationItemContainer;
